import {
  CreateBreakageReport,
  CreateBreakageReportRequest,
} from "../../domain/usecases/create-breakage-report";

import { HttpClient } from "../protocols/http";

export class DbCreateBreakageReport implements CreateBreakageReport {
  constructor(
    private readonly url: string,
    private readonly httClient: HttpClient
  ) {}
  async create(params: CreateBreakageReportRequest): Promise<void> {
    const res = await this.httClient.request({
      url: this.url,
      method: "post",
      body: params,
    });
    if (res.statusCode > 199 && res.statusCode < 300) {
      return res.body;
    } else {
      throw new Error(
        res.body.error.message ||
          res.body.error.data.message ||
          "Ocorreu um erro. Tente novamente em breve"
      );
    }
  }
}
